module.exports = __webpack_public_path__ + "img/3.38975b05.png";